import React from 'react';

interface ICurrencyDisplayProps {
    value?: number | string;
    showPlus?: boolean;
}

const CurrencyDisplay: React.FC<ICurrencyDisplayProps> = (props) => {
    if (props.value == null) return null;
    const numericValue = typeof props.value === 'string' ? parseFloat(props.value) : props.value;
    return <>{props.showPlus && numericValue > 0 && '+'}{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'}).format(numericValue)}</>
}

export default CurrencyDisplay;